import { normalizeAgentCode } from './signupAgent';

const STORAGE_KEY = 'npc_pending_referral_code';
const MAX_AGE_MS = 24 * 60 * 60 * 1000;

export function savePendingReferralCode(value) {
  const agentCode = normalizeAgentCode(value);
  if (!agentCode) {
    clearPendingReferralCode();
    return '';
  }

  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ agentCode, savedAt: Date.now() }));
  } catch (_) {}
  return agentCode;
}

export function readPendingReferralCode() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return '';

    const parsed = JSON.parse(raw);
    const agentCode = normalizeAgentCode(parsed?.agentCode);
    const savedAt = Number(parsed?.savedAt || 0);

    if (!agentCode || !savedAt || Date.now() - savedAt > MAX_AGE_MS) {
      clearPendingReferralCode();
      return '';
    }

    return agentCode;
  } catch (_) {
    clearPendingReferralCode();
    return '';
  }
}

export function clearPendingReferralCode() {
  try { sessionStorage.removeItem(STORAGE_KEY); } catch (_) {}
}
